import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector} from "react-redux";
// project import
// import useAuth from 'hooks/useAuth';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }) => {
  // const { isLoggedIn } = useAuth();
  const isLoggedIn = useSelector((state) => {
    return state.authuser.loggedIn
  });
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log("In AuthGate");
    console.log(isLoggedIn);
    if (!isLoggedIn) {
      navigate('/', {
        state: {
          from: location.pathname
        },
        replace: true
      });
      navigate('/', { replace: true });
    }
  }, [isLoggedIn, navigate, location]);

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
